module.exports = __webpack_public_path__ + "media/images/front/common/userIcon_vip-6884357be3cd26252a555c2cbe15862f.png";